import { render } from "./ComponentTextShow.vue?vue&type=template&id=33feec86&scoped=true"
import script from "./ComponentTextShow.vue?vue&type=script&lang=js"
export * from "./ComponentTextShow.vue?vue&type=script&lang=js"

import "./ComponentTextShow.vue?vue&type=style&index=0&id=33feec86&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33feec86"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ComponentTextShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33feec86"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33feec86', __exports__)) {
    api.reload('33feec86', __exports__)
  }
  
  module.hot.accept("./ComponentTextShow.vue?vue&type=template&id=33feec86&scoped=true", () => {
    api.rerender('33feec86', render)
  })

}


export default __exports__